/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
let VcLinkComponent = (_class = class VcLinkComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "flashMessages", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "api", _descriptor3, this);
    _initializerDefineProperty(this, "phase", _descriptor4, this);
    _initializerDefineProperty(this, "username", _descriptor5, this);
    _initializerDefineProperty(this, "useOTP", _descriptor6, this);
  }
  *linkAccounts(ev) {
    ev.preventDefault();
    const data = Object.fromEntries(new FormData(ev.target));
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands, @typescript-eslint/no-base-to-string
    const password = data['password'] + '';
    try {
      const resp = yield this.api.vagrant.registryServiceApi.vagrantCloudLink({
        username: this.username,
        password
      });
      const {
        require2fa
      } = resp;
      if (require2fa) {
        this.phase = '2fa';
      } else {
        this.flashMessages.success(this.intl.t('registries.reclaim.link.form.success.message'));
        this.args.onContinue?.();
      }
    } catch (err) {
      // Due to generator typing, this has to be a little heavy-handed
      const unwrappedError = yield err.json();
      const message = unwrappedError.message;
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw message ?? 'Incorrect username or password';
    }
  }
  *linkAccounts2fa(ev) {
    ev.preventDefault();
    const data = Object.fromEntries(new FormData(ev.target));
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands, @typescript-eslint/no-base-to-string
    const code = data['code'] + '';
    try {
      yield this.api.vagrant.registryServiceApi.vagrantCloud2Fa({
        username: this.username,
        code
      });
      this.flashMessages.success(this.intl.t('registries.reclaim.link.form.success.message'));
      this.args.onContinue?.();
    } catch (err) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const {
        message
      } = yield err.json();
      throw message;
    }
  }
  *sendOTP(ev) {
    ev.preventDefault();
    try {
      yield this.api.vagrant.registryServiceApi.vagrantCloudReset({
        username: this.username
      });
      this.useOTP = true;
      this.phase = 'auth';
    } catch (err) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const {
        message
      } = yield err.json();
      throw message;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "api", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "phase", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'auth';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "username", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "useOTP", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "linkAccounts", [task], Object.getOwnPropertyDescriptor(_class.prototype, "linkAccounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "linkAccounts2fa", [task], Object.getOwnPropertyDescriptor(_class.prototype, "linkAccounts2fa"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendOTP", [task], Object.getOwnPropertyDescriptor(_class.prototype, "sendOTP"), _class.prototype), _class);
export { VcLinkComponent as default };